<div class="form-group voffset row">
    <label class="label-group" for="open">Evento:</label>
    <div>
        <select matNativeControl  class="form-control" name="open" [(ngModel)]="openSpaceId" (change)="selectOpenSpace();">
            <option  class= "select-option" [value]="open.id" *ngFor="let open of openSpaces">  
                {{ (open.name.length>20) ? (open.name | slice:0:20) + '...':(open.name) }}
            </option> 
        </select>
    </div>
</div>

